<template>
    <div
        class="o-loading-overlay loading-overlay"
    >
        <svg-icon
            original
            name="icons/spiner"
        />
    </div>
</template>

<script>

export default {
    name: "OLoadingOverlay"
}
</script>

<style lang="scss">
@import "o-loading-overlay";
</style>
